import { SET_STUDENT_INFO, SET_UNENROLLED_STUDENT_DOCUMENTS, DOCUMENT_UPLOADED, BEGINNING_REQUEST, ERROR_DOCUMENT_REQUEST } from '../types'

const initialState = {
    isLoading: false,
    error: false,
    success: false,
    info:{},
    documents:[]
  }

export const unenrolledStudent = (state = initialState, action) => {
  switch(action.type){
    case SET_STUDENT_INFO:
    return {
        ...state,
        ...action.payload,
        isLoading: false,
        error: false,
      }
    case SET_UNENROLLED_STUDENT_DOCUMENTS:
      return {
        ...state,
        documents: {
          files: [
            ...action.payload
          ],
          error: null,
          loading: null,
          success: null
        }
      }
    
    case DOCUMENT_UPLOADED :
      return {
        ...state,
        documents:{
          ...state.documents,
          loading: false,
          error: false,
          success: true
        }
      }
    
    case BEGINNING_REQUEST :
      return {
        ...state,
        isLoading: true,
        error: false
      }

      case ERROR_DOCUMENT_REQUEST :
      return {
        ...state,
        documents: {
          ...state.documents,
          loading: false,
          error: true
        }
      }
    default:
      return state
  }
}